/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Modern, styled, useCallback, useFlux } from 'fierry/react.old';

import Behavior from 'shared/client/behavior';
import Layout from 'shared/client/layout/state';
import Url from 'shared/client/url';

import Container from 'fierry/react.old/skeleton/pane/container/mobile';

import Header from 'fierry/react.old/skeleton/header'
import Sidebar from 'fierry/react.old/skeleton/sidebar'


const Space = styled.div`

  pointer-events: none;
  flex-grow: 1;
`;


const Component = ({ collapsed, header, sidebar, onSidebarClick, ...props }) =>
(
  <Container>

    <Header
      header = {header}
    />

    <Space />

    <Sidebar
      sidebar = {sidebar}
      collapsed = {collapsed}
      onClick = {onSidebarClick}
    />

  </Container>
);


const OnSidebarClick = (event, layout, url) =>
{
  if (layout.getPaneCollapsed() && url.getRoute().getValue() === '/')
  {
    layout.setPaneCollapsed(false);
  }
}


export default (props) =>
{
  const [ behavior, layout, url ] = useFlux(Behavior, Layout, Url);

  const onSidebarClick = useCallback(OnSidebarClick, [ layout, url ]);

  return <Component {...props} collapsed = {behavior.isPaneCollapsed()} onSidebarClick = {onSidebarClick} />;
}
